import { render, staticRenderFns } from "./biOrderDetail.vue?vue&type=template&id=7a28f95a&scoped=true"
import script from "./biOrderDetail.vue?vue&type=script&lang=js"
export * from "./biOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a28f95a",
  null
  
)

export default component.exports